module.exports = __webpack_public_path__ + "img/30.5.COD.fed4acde.png";